import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h3 } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.a `
  display: flex;
  padding-bottom: 20px;
  margin-bottom: 20px;
  color: inherit;
  text-decoration: none;
  border-bottom: 1px solid ${brand.black};
`;
const ImageWrapper = styled.div `
  display: none;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: auto;

  @media ${from(Device.Tablet)} {
    display: block;
  }
`;
const Image = styled.img `
  max-width: none;
  width: 100%;
  height: auto;
  ${transition('transform')};
  transform-origin: 50% 50%;

  ${Container}:hover & {
    transform: scale(1.1);
  }
`;
const CardContent = styled.div `
  padding: 0;

  @media ${from(Device.Tablet)} {
    padding: 20px 46px 0 20px;
  }
`;
const Title = styled.h3 `
  ${h3};
  margin-bottom: ${fluid(20, 10)};
`;
const TextContent = styled.p ``;
const Categories = styled.div `
  position: relative;
  margin-top: 20px;
  padding-left: 22px;

  svg {
    position: absolute;
    top: 4px;
    left: 0;
    color: ${brand.orange};
  }

  span {
    font-size: ${fluid(16, 20)};
    line-height: ${fluid(20, 24)};
    color: ${brand.orange};
    text-transform: uppercase;

    &:not(:last-child) {
      &::after {
        content: ',';
        margin-right: 5px;
      }
    }
  }
`;
export const SearchResultCardStyles = {
    CardContent,
    Categories,
    Container,
    Image,
    ImageWrapper,
    TextContent,
    Title,
};
